import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {Gallery as DXGallery} from 'devextreme-react';


export default class Gallery extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: this.props.visible,
            disabled: this.props.disabled,
            selectedIndex: this.props.selectedIndex,
        };

        this.itemTemplate = this.itemTemplate.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        // this.onOptionChanged = this.onOptionChanged.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            visible: props.visible,
            disabled: props.disabled,
            // selectedIndex: props.selectedIndex,
        });
    }

    itemTemplate(template_id) {
        return window[template_id];
        // return function(container, options) {
        //     console.log('itemTemplate', container, options)
        //     ReactDOM.render(tmpl(options), container);
        // }
    }

    onItemClick(e) {
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                itemClick: {
                    data: e.itemData,
                    itemIndex: e.itemIndex
                }
            });
        }
    }

    onOptionChanged(e) {
        if (e.name === 'selectedItem') {

            console.log('addedItems', e.addedItems)
            console.log('removedItems', e.removedItems)
            console.log('value', e.value)
            console.log('dataSource', this.props.dataSource)

            // if (typeof e.value === 'string') {
                this.setState({selectedIndex: this.props.dataSource.indexOf(e.value)});
            console.log('selectedIndex', this.state.selectedIndex)
            // } else
            //     if (typeof e.value === 'object') {
            //         this.setState({selectedItem: e.value});
            //     }

            // this.setState({selectedIndex: this.props.dataSource.indexOf(e.value)});

            // this.setState({selectedItemKeys: [e.value.id]});
        }
        return false
    }

    onSelectionChanged(e) {
        const {dataSource} = this.props;

        const selectedIndex = dataSource.indexOf(e.addedItems[0]);

        // if (setProps) {
        //     setProps({
        //         selectionChanged: {
        //             selectedIndex: selectedIndex
        //         }
        //     });
        // }
        this.setState({selectedIndex});
    }

    render() {
        let {itemRender} = this.props;

        // if (itemTemplate && typeof itemTemplate === 'string' && itemTemplate !== 'item'){
        //     itemTemplate = this.itemTemplate(itemTemplate);
        // }
        if (itemRender && typeof itemRender === 'string'){
            itemRender = this.itemTemplate(itemRender);
        }

        return (
            <DXGallery
                {...omit(['loading_state', 'setProps'], this.props)}
                // itemTemplate={itemTemplate}
                itemRender={itemRender}
                disabled={this.state.disabled}
                visible={this.state.visible}
                // selectedItem={this.state.selectedItem}
                selectedIndex={this.state.selectedIndex}
                onSelectionChanged={this.props.onSelectionChanged || this.onSelectionChanged}
                onItemClick={this.props.onItemClick || this.onItemClick}
                // onOptionChanged={this.props.onOptionChanged || this.onOptionChanged}
            />
        );
    }

}

Gallery.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * Specifies the shortcut key that sets focus on the UI component
     */
    accessKey: PropTypes.string,
    /**
     * The time, in milliseconds, spent on slide animation
     */
    animationDuration: PropTypes.number,
    /**
     * Specifies whether or not to animate the displayed item change
     */
    animationEnabled: PropTypes.bool,
    /**
     * Binds the UI component to data
     */
    dataSource: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object)]),
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies whether the UI component can be focused using keyboard navigation
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * A Boolean value specifying whether or not to allow users to switch between items by clicking an indicator
     */
    indicatorEnabled: PropTypes.bool,
    /**
     * Specifies the width of an area used to display a single image
     */
    initialItemWidth: PropTypes.number,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a custom component.
     */
    itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * The time period in milliseconds before the onItemHold event is raised
     */
    itemHoldTimeout: PropTypes.number,

    /**
     * Dash event
     */
    itemClick: PropTypes.object,

    /**
     * An alias for the itemTemplate property specified in React. Accepts a rendering function.
     */
    itemRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * An array of items displayed by the UI component
     */
    items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object)]),
    /**
     * Specifies a custom template for items
     */
    itemTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * A Boolean value specifying whether or not to scroll back to the first item after the last item is swiped
     */
    loop: PropTypes.bool,
    /**
     * The text or HTML markup displayed by the UI component if the item collection is empty
     */
    noDataText: PropTypes.string,
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed when a collection item is clicked or tapped
     */
    onItemClick: PropTypes.func,
    /**
     * A function that is executed when a collection item is right-clicked or pressed
     */
    onItemContextMenu: PropTypes.func,
    /**
     * A function that is executed when a collection item has been held for a specified period
     */
    onItemHold: PropTypes.func,
    /**
     * A function that is executed after a collection item is rendered
     */
    onItemRendered: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed when a collection item is selected or selection is canceled
     */
    onSelectionChanged: PropTypes.func,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * The index of the currently active gallery item
     */
    selectedIndex: PropTypes.number,
    /**
     * The selected item object
     */
    selectedItem: PropTypes.object,

    /**
     * Dash event
     */
    selectionChanged: PropTypes.object,

    /**
     * A Boolean value specifying whether or not to display an indicator that points to the selected gallery item
     */
    showIndicator: PropTypes.bool,
    /**
     * A Boolean value that specifies the availability of the "Forward" and "Back" navigation buttons
     */
    showNavButtons: PropTypes.bool,
    /**
     * The time interval in milliseconds, after which the gallery switches to the next item
     */
    slideshowDelay: PropTypes.number,
    /**
     * Specifies if the UI component stretches images to fit the total gallery width
     */
    stretchImages: PropTypes.bool,
    /**
     * A Boolean value specifying whether or not to allow users to switch between items by swiping
     */
    swipeEnabled: PropTypes.bool,
    /**
     * Specifies the number of the element when the Tab key is used for navigating
     */
    tabIndex: PropTypes.number,
    /**
     * Specifies whether the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies whether or not to display parts of previous and next images along the sides of the current image
     */
    wrapAround: PropTypes.bool,

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

Gallery.defaultProps = {
    accessKey: null,
    animationDuration: 400,
    animationEnabled: true,
    dataSource: null,
    disabled: false,
    elementAttr: {},
    focusStateEnabled: true,
    // height: undefined,
    // hint: undefined,
    hoverStateEnabled: false,
    indicatorEnabled: true,
    // initialItemWidth: undefined,
    itemComponent: null,
    itemHoldTimeout: 750,
    itemRender: null,
    items: null,
    itemTemplate: 'item',
    loop: true,
    noDataText: 'No data to display',
    onContentReady: null,
    onDisposing: null,
    onInitialized: null,
    onItemClick: null,
    onItemContextMenu: null,
    onItemHold: null,
    onItemRendered: null,
    onOptionChanged: null,
    onSelectionChanged: null,
    rtlEnabled: false,
    selectedIndex: 0,
    selectedItem: null,
    showIndicator: true,
    showNavButtons: true,
    slideshowDelay: 0,
    stretchImages: false,
    swipeEnabled: true,
    tabIndex: 0,
    visible: true,
    // width: undefined,
    wrapAround: false
};
